import * as modal from '../reducers/modalReducer';
import { getItems } from '../reducers/cartReducer';

export const purchaseLimitsRequest = () => ({
  type: 'PURCHASE_LIMITS_REQUEST',
  payload: null,
});

export const openPurchaseLimits = () => (dispatch, getState) => {
  const state = getState();
  const ticketLines = getItems(state);
  if (ticketLines.length === 0) {
    dispatch(purchaseLimitsRequest());
  }
  dispatch(modal.openModal({
    modalType: 'PURCHASE_LIMITS_FORM',
    modalProps: {},
  }));
};



// WEBPACK FOOTER //
// ./src/actions/purchase_limits_action.js